import React, { Component } from 'react';
export default class MailingList extends Component {
  render() {
    return (
      <div>
        <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css" />

        <div id="mc_embed_signup">
          <form
            action="https://propertyhints.us19.list-manage.com/subscribe/post?u=32343fdeff92f943bc7e1db83&amp;id=666000d249"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            className="validate"
            target="_blank"
            novalidate
          >
            <div id="mc_embed_signup_scroll">
              <label for="mce-EMAIL">Subscribe to our mailing list to keep up to date</label>
              <input type="email" name="EMAIL" className="email" id="mce-EMAIL" placeholder="email address" required />
              <div style={{ position: 'absolute', left: '-5000px', ariaHidden: 'true' }}>
                <input type="text" name="b_32343fdeff92f943bc7e1db83_666000d249" tabindex="-1" value="" />
              </div>
              <div className="clear">
                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button" />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MailingList.jsx